module.exports = __webpack_public_path__ + "img/warn.04113525.png";